import type { QueryClient } from "@tanstack/react-query";

import { CASE_KEY } from "@/api";

/**
 * How long a gesture waits for the Vorgang to be read again before its own
 * answer goes in anyway (review 13/14, M-1). Long enough for an ordinary
 * answer — the banner (13b) and the half-released panel (13f) came from
 * not waiting at all —, short enough that a Vorgang GET that never answers
 * (no timeout, a retry paused offline) does not keep a calculation the
 * server already holds out of sight.
 */
export const CASE_REFETCH_WAIT_MS = 3_000;

/**
 * The Vorgang read again (exact key — not the prefix, or the calculation's
 * own entry would be refetched too), waited for at most
 * `CASE_REFETCH_WAIT_MS`. Resolves either way; a refetch still in flight
 * lands on its own afterwards, and a failed one never throws here.
 */
export async function refetchCase(client: QueryClient, caseId: string): Promise<void> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const waited = new Promise<void>((resolve) => {
    timer = setTimeout(resolve, CASE_REFETCH_WAIT_MS);
  });
  try {
    await Promise.race([client.invalidateQueries({ queryKey: CASE_KEY(caseId), exact: true }), waited]);
  } finally {
    clearTimeout(timer);
  }
}
